import MetricsContainer from "../../components/MetricsContainer";

const Metrics = () => {
  return (
    <>
      <MetricsContainer />{" "}
    </>
  );
};

export default Metrics;
